import React, { useState } from "react"
import { Container, Row, Col } from "reactstrap"
import MetaTags from "react-meta-tags"
import { Redirect } from "react-router-dom"

const NotFound404 = () => {
  return (
    <div className="page-content">
      <MetaTags>
        <title>{process.env.REACT_APP_TITLE}</title>
      </MetaTags>
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="text-center mb-5">
              <h1 className="display-2 font-weight-medium">
                4<i className="bx bx-buoy bx-spin text-primary display-3" />4
              </h1>
              <h4 className="text-uppercase">
                Page not found
              </h4>
              
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default NotFound404
